import React from 'react';
import { useTheme } from '../../store/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme, isDark } = useTheme();

  return (
    <button
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={`Current theme: ${theme}. Switch to ${isDark ? 'light' : 'dark'} mode`}
      title={`Current theme: ${theme}. Click to switch to ${isDark ? 'light' : 'dark'} mode`}
      data-theme={theme}
    >
      {isDark ? (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
      ) : (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="12" r="5" />
          <path d="m12 1-1 3h2l-1-3zM12 20l-1 3h2l-1-3zM4.22 4.22l1.42 1.42 1.41-1.42-1.41-1.42zM18.36 18.36l1.42 1.42 1.41-1.42-1.41-1.42zM1 12l3-1v2l-3-1zM20 12l3-1v2l-3-1zM4.22 19.78l1.42-1.42 1.41 1.42-1.41 1.42zM18.36 5.64l1.42-1.42 1.41 1.42-1.41 1.42z" />
        </svg>
      )}
    </button>
  );
};

export default ThemeToggle;
